import { SxProps, Theme } from '@mui/system';

const styles = {
  downloadRow: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 1,
    cursor: 'pointer',
    color: 'primary.main',
    fontWeight: 600,
  },
  description: { mt: 1.5, color: 'text.secondary' },
  uploadButton: { mt: 3, width: 'fit-content' },
  url: {
    color: 'primary.main',
  },
  bottomBorder: { borderBottom: '1px solid', borderColor: 'common.border' },
  crossContainer: {
    position: 'relative',
    display: 'flex',
    alignSelf: 'flex-start',
    flexDirection: 'row',
    width: 'fit-content',
  },
  fileChip: {
    position: 'relative',
    display: 'inline-block',
    padding: '12px 16px',
    border: '1px dashed',
    borderColor: 'divider',
    borderRadius: '10px',
    mt: 2,
    backgroundColor: 'background.paper',
    maxWidth: '100%',
  },
  removeIcon: {
    position: 'absolute',
    top: '-9px',
    right: '-14px',
    p: 0.5,
    '&:hover': { backgroundColor: 'grey.100' },
  },
  fileName: { wordBreak: 'break-all', fontSize: 14, mb: 0.5 },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 1.5,
    px: 3,
    py: 1,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
